import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const DetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$licenseId`,
    component: lazyRouteComponent(() => import('./LicenseDetails'))
  })
